import { ReactNode } from "react";

type OptionType = {
	title: string;
	answer: ReactNode;
};

type QuestionsType = {
	title: string;
	questions: OptionType[];
};

export const FAQQuestionsFincaraiz: QuestionsType[] = [
	{
		title: "Publicación de Avisos",
		questions: [
			{
				title: "¿Cómo publico mi aviso en Finca Raíz?",
				answer: (
					<p>
						Debes diligenciar el formulario de publicación con los datos de tu inmueble,
						luego incluir tus datos personales, aceptar los términos de uso y con un
						solo clic podrás{" "}
						<b>
							<a href="https://ov.fincaraiz.com.co/login" target="_blank">
								Publicar tu Inmueble Gratis
							</a>
						</b>
					</p>
				),
			},
			{
				title: "¿Tiene algún costo la publicación de mis avisos?",
				answer: (
					<p>
						Si tienes hasta dos inmuebles, la publicación en nuestro portal es gratuita.
						Si son más de dos avisos, ofrecemos cómodos precios y servicios a la medida
						de tus necesidades.
					</p>
				),
			},
			{
				title: "¿Qué tipo de ofertas puedo publicar?",
				answer: (
					<p>
						Si eres un usuario particular puedes publicar tus avisos evitando los
						proyectos nuevos, planos, renders, remates y anuncios que no estén
						relacionados con venta y arriendo de inmuebles.
					</p>
				),
			},
			{
				title: "Qué información puedo ingresar para la publicación de mi inmueble?",
				answer: (
					<p>
						Puedes publicar una breve descripción de tu inmueble en la cual especifique
						su ubicación, área, precio y demás características que generen interés a los
						usuarios. También puedes cargar hasta 20 fotos.
					</p>
				),
			},
			{
				title: "¿Cómo verificar que mi inmueble está publicado?",
				answer: (
					<p>
						Recibirás un mensaje de confirmación vía E- mail con el Nº de referencia de
						tu aviso que puede tomar un lapso de 25 minutos en verse publicado en el
						portal. Ingresando éste número en el buscador de la página, podrás ver tu
						publicación.
					</p>
				),
			},
			{
				title: "¿Cómo destacar mi aviso?",
				answer: (
					<>
						<p>
							Fincaraíz.com.co cuenta con una oferta de productos que te ayudarán a
							lograr tu objetivo de vender y/o arrendar tu inmueble. Todos los
							clientes particulares (personas naturales diferentes de agentes
							inmobiliarios, inmobiliarias y constructores) pueden activar dentro de
							su oficina virtual los siguientes productos:
						</p>
						<ul>
							<li>
								Destacado Especial: Obtén más contactos diferenciando tu aviso con
								una etiqueta en tu inmueble con la palabra “DESTACADO” y un borde
								azul. Posiciónalo en primeras páginas y además resáltalo en el mapa
								de las apps. Tu Destacado Especial se activará inmediatamente en
								todas las plataformas después de tu compra. Puedes adquirir este
								producto con una duración de 7, 30 y hasta 60 días.
							</li>
							<li>
								Turbo: Automáticamente te empujamos a la cima 1 vez al día durante
								una semana.Tu turbo se activará entre 0 a 24 horas después de tu
								compra, subiendo tu aviso al inicio de la lista durante 7 días en
								todas las plataformas.
							</li>
							<li>
								Inmueble Destacado: Posiciona tu aviso en las primeras páginas de la
								lista de resultados con un borde azul. Tu Inmueble destacado se
								activará inmediatamente en todas las plataformas después de tu
								compra.Puedes adquirir este producto con una duración de 30 y 60
								días.
							</li>
						</ul>
						<p>
							Adicionalmente y de acuerdo a tu necesidad también puedes adquirir
							dentro de tu oficina virtual los siguientes Packs:
						</p>
						<ul>
							<li>
								Pack me Urge: Tu inmueble se posiciona en las primeras páginas de
								resultados con un borde azul y una etiqueta con la palabra
								“OPORTUNIDAD”. Sé visible en el detalle de otros inmuebles similares
								al tuyo, y vé a la cima de resultados con 2 Asciende tu aviso que
								activarás cuando tú quieras.
							</li>
							<li>
								Pack Necesito: Obtendrás una etiqueta con la palabra “OPORTUNIDAD”,
								serás más visible al rotar en las primeras páginas de resultados con
								un borde azul, y además ve a la cima de resultados con 2 Asciende tu
								aviso que activarás cuando tu quieras.
							</li>
							<li>
								Pack Quiero: Obtendrás una etiqueta con la palabra “OPORTUNIDAD”,
								además ve a la cima de resultados con 2 Asciende tu aviso que
								activarás cuando tu quieras.
							</li>
						</ul>
					</>
				),
			},
			{
				title: "¿Cuándo y por cuánto tiempo saldrá publicado mi aviso?",
				answer: (
					<p>
						Tu inmueble se verá publicado en nuestro portal en un tiempo aproximado de
						25 minutos. Los avisos gratis tienen vigencia de 60 días y los avisos
						adicionales tienen vigencia de 30 días.
					</p>
				),
			},
			{
				title: "¿Cómo puedo modificar o eliminar mi aviso?",
				answer: (
					<p>
						En tu Menú Personal ingresa tus datos de usuario (E- mail y clave), en la
						pestaña Mis Inmuebles podrás seleccionar el aviso que quieras modificar o
						eliminar.
					</p>
				),
			},
			{
				title: "¿Cómo me contactarían los clientes?",
				answer: (
					<p>
						Los usuarios interesados en tu inmueble te contactarán directamente a través
						de tu E- mail y teléfono, luego de llenar el formulario adjunto al aviso. Si
						eres un profesional y dispones de una Oficina Virtual Constructor, tu
						microsite te ofrece la posibilidad de monitorear el impacto de tu
						publicación.
					</p>
				),
			},
			{
				title: "¿Qué debo hacer si olvidé mi clave?",
				answer: (
					<p>
						En tu Menú Personal encontrarás la opción de Recordar Clave, en la cual
						podrás digitar tu E-mail de contacto y en pocos minutos recibirás un mensaje
						de recuperación.
					</p>
				),
			},
			{
				title: "¿Finca Raíz cobra alguna Comisión por la publicación de mis avisos?",
				answer: <p>Ninguna. Finca Raíz no cobra comisión.</p>,
			},
			{
				title:
					'¿Qué pasa cuando mi aviso queda como Pendiente de Aprobación o cuando aparece "Pendiente" en el Menú Personal?',
				answer: (
					<p>
						Significa que el aviso se encuentra en proceso de moderación, es decir, la
						verificación y validación de contenido puede tardar máximo 24 horas. El
						aviso puede ser rechazado o eliminado cuando se trate de proyectos nuevos de
						un agente inmobiliario o constructor, contenga planos o renders, anuncie
						remates o información que no esté relacionada con venta y arriendo de
						inmuebles.
					</p>
				),
			},
			{
				title:
					'¿Qué es y qué se debe hacer cuando mi aviso aparece en estado "Pendiente de Pago"?',
				answer: (
					<p>
						Nuestro portal permite la publicación gratuita de hasta 2 avisos a personas
						naturales. Si un tercer aviso es publicado es necesario realizar el pago
						antes de su difusión. Cuando el aviso queda pendiente de pago en el área de
						gestión aparece un enlace que dice “Pagar aviso”. Al hacer clic allí lo
						enviamos al sistema de pagos, una vez recibido el pago, el aviso queda
						publicado con un lapso de 25 minutos.
					</p>
				),
			},
		],
	},
	{
		title: "Búsqueda de Inmuebles",
		questions: [
			{
				title: "¿Debo registrarme para buscar un inmueble?",
				answer: (
					<p>
						No es necesario registrarse para consultar nuestros clasificados, puedes
						buscar los inmuebles por palabras (Ejemplo: Casas en Bogotá) o por su
						ubicación en el mapa de Colombia dispuesto en nuestra página principal.
					</p>
				),
			},
			{
				title: "¿Que es una Búsqueda Automática?",
				answer: (
					<p>
						La Búsqueda Automática es un sistema de alerta por el cuál puedes programar
						los tipos de inmuebles de tu interés y recibir la información en tu correo
						electrónico. Debes registrarte con tu correo en nuestro portal para recibir
						las diferentes ofertas según la ubicación y las características del inmueble
						que buscas.
					</p>
				),
			},
			{
				title: "¿Puedo contactar directamente al dueño del inmueble?",
				answer: (
					<p>
						Sí, al encontrar un inmueble que se ajusta a tus necesidades, puedes ver el
						teléfono de contacto o enviar un E-mail a través del formulario adjunto al
						aviso.
					</p>
				),
			},
			{
				title: "¿Con qué frecuencia puedo encontrar nuevas ofertas de inmuebles",
				answer: (
					<p>
						Continuamente encuentras nuevas ofertas. Te invitamos a consultar
						diariamente nuestro portal durante tu proceso de búsqueda de inmuebles y
						suscríbete a nuestro sistema de alerta por correo electrónico.
					</p>
				),
			},
		],
	},
];

export const FAQQuestionsInfocasas = (
	main_domain: string,
	site_name: string,
	country_code: string
) => {
	const data: QuestionsType[] = [
		{
			title: "Registro",
			questions: [
				{
					title: "¿Cómo me registro?",
					answer: (
						<p>
							Para registrarse en {main_domain} debe ir a Ingresar {`>`} Regístrese
							aquí, ubicada en la parte superior derecha de la página de inicio. Luego
							de elegir un plan de pago, completar los datos y aceptar los términos y
							condiciones de uso del sitio, puede comenzar a usar el portal. Si desea
							registrarse ahora, haga{" "}
							<a
								href={`https://${main_domain}/sitio/index.php?mid=inmobiliarias&func=registro_1`}>
								click aquí.
							</a>
						</p>
					),
				},
				{
					title: "¿Por qué debo ingresar datos de contacto?",
					answer: (
						<p>
							Los datos de contacto (Nombre de la inmobiliaria, teléfonos, dirección,
							persona de contacto, e-mail, página web) que figuran en las fichas de
							propiedades y en el directorio inmobiliario sirven para que los
							interesados puedan contactarse con las inmobiliarias.
						</p>
					),
				},
				{
					title: "Seguridad de los datos de registro.",
					answer: (
						<p>
							Sus datos de registro quedarán guardados en nuestra base de datos junto
							con la de todos nuestros otros usuarios. La información personal está
							protegida para mantenerla en total confidencialidad, conforme a la Ley
							Nº 18.331 y sus respectivas reglamentaciones.
						</p>
					),
				},
			],
		},
		{
			title: "Publicaciones",
			questions: [
				{
					title: "¿Cómo puedo publicar un aviso de mi propiedad en www.infocasas.com.uy?",
					answer: (
						<p>
							Para publicar una propiedad debe, en primer lugar, ser una inmobiliaria
							y estar registrada como tal en el portal Infocasas. Una vez que ingrese
							a su sesión, debe dirigirse al Panel y hacer click en el botón “Agregar
							propiedad”.Debe completar los datos obligatorios de la propiedad, subir
							fotos y localizar la zona o la dirección del inmueble en el mapa. Una
							vez completado, debe hacer click en “Guardar” y la propiedad queda
							publicada.
						</p>
					),
				},
				{
					title: "¿Cuánto tiempo dura la publicación de mis propiedades?",
					answer: (
						<p>
							La duración de las publicaciones depende directamente de la suscripción
							de cada inmobiliaria y el plan elegido.
						</p>
					),
				},
				{
					title: "¿De qué tamaño deben ser las fotos?",
					answer: (
						<p>
							Es muy importante que se suban varias fotografías, y que sean nítidas e
							illustrativas. Esto generará más visitas a su publicación. Se permite un
							máximo de 15 fotos por propiedad. Es importante evitar imágenes
							superiores a 1 Mb para optimizar el funcionamiento del sitio.
						</p>
					),
				},
				{
					title: "¿Cómo modifico o desactivo una propiedad?",
					answer: (
						<p>
							Para modificar o desactivar propiedades, debe ingresar a su sesión y
							dirigirse al panel de propiedades. Allí podrá ver el listado de todas
							las publicaciones. Para editar la información o cambiar las fotos debe
							situar el cursor sobre el ícono de la columna “Acciones” de la propiedad
							que desee modificar. Allí se desplegará una lista con las siguientes
							opciones: Modificar, Editar ubicación, Editar imágenes, Destacar
							propiedad, Eliminar propiedad. Si quiere dar de baja o eliminar una
							publicación, solo debe hacer click en el tick de la columna
							“Habilitado”.
						</p>
					),
				},
			],
		},
		{
			title: "Edición de datos",
			questions: [
				{
					title: "¿Cómo cambio mi E-mail?",
					answer: (
						<p>
							Para modificar su e-mail de usuario o cualquier dato de contacto deberá
							ingresar a su sesión y dirigirse a Editar Datos. Le enviaremos un
							mensaje a su nueva casilla de correo y le solicitaremos que confirme su
							solicitud haciendo click en el link. Una vez confirmado, podrá ingresar
							al sitio con su nuevo E-mail.
						</p>
					),
				},
				{
					title: "¿Qué hago si olvide mi contraseña?",
					answer: (
						<p>
							Si no puede recordar su contraseña, diríjase a Ingresar {`>`} Olvidé mi
							contraseña. Complete su dirección de correo electrónico y
							automáticamente le enviaremos un mensaje a su casilla recordándole su
							contraseña.
						</p>
					),
				},
			],
		},
		{
			title: "Búsqueda de propiedades, navegación y favoritos",
			questions: [
				{
					title: "¿Cómo busco propiedades?",
					answer: (
						<p>
							El buscador se encuentra a la izquierda en la página principal del
							sitio. Debe completar como mínimo el tipo de operación (Alquiler, Venta,
							Alquiler temporal) para ejecutar la búsqueda. Si desea buscar por
							título, inmobiliaria o código de referencia, debe llenar el campo de
							búsqueda avanzada que se encuentra en la parte inferior del buscador.
						</p>
					),
				},
				{
					title: "¿Cómo guardo Favoritos?",
					answer: (
						<p>
							Los favoritos son todas las publicaciones que le interesen y desee
							guardar. Para guardar una publicación en sus favoritos, solo debe hacer
							un click en el corazón que aparece en la ficha de cada propiedad. Para
							ver sus favoritos, tiene que hacer click en el botón “Mis favoritos” en
							el inferior izquierdo de la página.
						</p>
					),
				},
				{
					title: "¿Cómo hago para contactarme con las inmobiliarias?",
					answer: (
						<p>
							Para contactar a la inmobiliaria que vende o alquila la propiedad de su
							interés, puede enviar su consulta completando el formulario que aparece
							a la derecha de cada ficha de propiedad. Además allí encontrará los
							demás datos de contacto.
						</p>
					),
				},
				{
					title: "¿Cómo funciona el Directorio Inmobiliario?",
					answer: (
						<p>
							El Directorio Inmobiliario es una sección del sitio donde puede
							encontrar todas las inmobiliarias que publican, ya sea por nombre, por
							orden alfabético, por inmobiliarias destacadas o por la cantidad de
							propiedades que tienen. Cada inmobiliaria tiene una ficha con sus datos
							y un listado de propiedades.
						</p>
					),
				},
				{
					title: "¿Cómo recomiendo una propiedad?",
					answer: (
						<p>
							Infocasas le permite recomendar propiedades y enviarlas por mail y/o
							compartirlas en redes sociales como Facebook y Twitter. En cada ficha de
							propiedad encontrará los botones correspondientes para realizar estas
							acciones.
						</p>
					),
				},
			],
		},
		{
			title: "Contacto",
			questions: [
				{
					title: "¿Cómo me contacto?",
					answer: (
						<>
							<p>
								Si no encontró la respuesta que buscaba, contáctenos a{" "}
								{`info@${site_name}.com.${country_code}`}.
							</p>
							<p>¡No dude en consultarnos!</p>
						</>
					),
				},
			],
		},
	];
	return data;
};

